import Why from '@/components/Why';

export default Why;


